import type { FC } from 'react';

type ParaProps = {
	children: React.ReactNode;
	className?: string;
};

export const Para: FC<ParaProps> = ({ children, className }) => {
	const baseStyles = 'text-gray-700 dark:text-gray-300';
	return <p className={`${baseStyles} ${className ?? ''}`}>{children}</p>;
};
